import axiosInstance from "../../../api/axiosInstance";

export const fetchHomonyms = async (params) => {
  try {
    const res = await axiosInstance.get("/public/homonym", { params });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchHomonymById = async (id) => {
  try {
    const res = await axiosInstance.get(`/public/homonym/${id}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const searchHomonyms = async (params) => {
  try {
    const res = await axiosInstance.get("/public/homonym/search", { params });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};
